import React from "react"
import {
    styled,
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow,
    tableRowClasses,
} from "@mui/material"
import {numStringToCurrency} from "../bloom-utils/transformations"

const StyledTableCell = styled(TableCell)(({theme}) => {
    const primaryColor = theme.ALTERSVORSORGETABLE.primaryColor
    const border = `1px solid ${theme.ALTERSVORSORGETABLE.primaryColor}`
    return ({
        borderBottom: border,
        padding: "4px",
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: primaryColor,
            color: `oklch(from ${primaryColor} clamp(0.15, (0.5 - l) * infinity, 0.98) 0 0)`,
        },
        [`&.${tableCellClasses.body}`]: {
            color: "black",
            borderRight: border,
        },
        [`&.${tableCellClasses.body}:last-child`]: {
            borderRight: "none",
        },
    })
})

const StyledTableRow = styled(TableRow)(({theme}) => ({
    borderBottomColor: theme.ALTERSVORSORGETABLE.primaryColor,
}))

const BoldTableRow = styled(TableRow)(({theme}) => ({
    [`&.${tableRowClasses.root} > td`]: {
        borderBottomWidth: "2px",
    },
}))

const firstRows = [
    {
        title: "Versorgungsziel monatlich",
        brutto: null,
        netto: "ziel",
        comp: StyledTableRow,
    },
    {
        title: "Bestehende gesetzliche Versorgung monatlich",
        brutto: "gesetzlicheVersorgungBrutto",
        netto: "gesetzlicheVersorgungNetto",
        comp: StyledTableRow,
    },
    {
        title: "Bestehende betriebliche Versorgung monatlich",
        brutto: "betrieblicheVersorgungBruttoEuro",
        netto: "betrieblicheVersorgungNettoEuro",
        comp: StyledTableRow,
    },
    {
        title: "Bestehende private Versorgung monatlich",
        brutto: "privateVersorgungBruttoEuro",
        netto: "privateVersorgungNettoEuro",
        comp: StyledTableRow,
    },
    {
        title: "Weitere Einkünfte monatlich",
        brutto: "summeAllerBruttoEinkuenfteEuro",
        netto: "nettoVersorgungAusEinkuenften",
        comp: BoldTableRow,
    },
    {
        title: "Gesamt",
        brutto: "summeVersorgungUndEinkuenfteEuro",
        netto: "nettoeinkommen",
        comp: StyledTableRow,
    },
    {
        title: "Versorgungslücke im 1. Jahr",
        brutto: "",
        netto: "luecke",
        comp: StyledTableRow,
    },
    {
        title: "Kapitalbedarf zum Renteneintritt",
        brutto: "",
        netto: "gesamtKapitalbedarfEuro",
        comp: StyledTableRow,
    },
]

export const AltersvorsorgeberatungTable = ({getDataFromPointer, widget}) => {
    const {connections} = widget
    const data = getDataFromPointer(connections?.origin?.pointer)

    return data && <TableContainer>
        <Table sx={{ minWidth: 550 }}>
            <TableHead>
                <StyledTableRow>
                    <StyledTableCell>Art der Versorgung bzw. des Bedarf</StyledTableCell>
                    <StyledTableCell align="right">Brutto {data.jahr}</StyledTableCell>
                    <StyledTableCell align="right">Netto {data.jahr}</StyledTableCell>
                </StyledTableRow>
            </TableHead>
            <TableBody>
                {firstRows.map(({comp: RowComp, ...row}) => <RowComp key={row.title}>
                    <StyledTableCell>{row.title}</StyledTableCell>
                    <StyledTableCell
                        align="right">{row.brutto &&
                        <strong>{numStringToCurrency(data[row.brutto])} €</strong>}</StyledTableCell>
                    <StyledTableCell
                        align="right">{row.netto &&
                        <strong>{numStringToCurrency(data[row.netto])} €</strong>}</StyledTableCell>
                </RowComp>)}
            </TableBody>
        </Table>
    </TableContainer>
}